import { c as _c } from "react/compiler-runtime";
import { Form } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import TemplatedText from '../../../components/templated-text';
import type { CustomQuestionsFormData } from '../../../types';
import { previewLabel } from '../../../utils/preview-label';
type MultipleChoicePreviewProps = {
  questionIndex: number;
};
const MultipleChoicePreview = t0 => {
  const $ = _c(18);
  const {
    questionIndex
  } = t0;
  const {
    control
  } = useFormContext();
  const t1 = `questions.${questionIndex}.label`;
  const t2 = `questions.${questionIndex}.required`;
  const t3 = `questions.${questionIndex}.options`;
  let t4;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3) {
    t4 = [t1, t2, t3];
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== control || $[5] !== t4) {
    t5 = {
      control,
      name: t4
    };
    $[4] = control;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const [label, required, options] = useWatch(t5);
  let t6;
  if ($[7] !== label || $[8] !== required) {
    t6 = previewLabel(label, required, _temp);
    $[7] = label;
    $[8] = required;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const labelWithOptional = t6;
  let t7;
  if ($[10] !== labelWithOptional) {
    t7 = labelWithOptional && <TemplatedText value={labelWithOptional} />;
    $[10] = labelWithOptional;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = `questions.${questionIndex}.preview`;
  let t9;
  if ($[12] !== options) {
    t9 = options || [];
    $[12] = options;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
    t10 = <Form.RadioGroup label={t7} name={t8} options={t9} />;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
export default MultipleChoicePreview;
function _temp(trimmed) {
  return `${trimmed} (Optional)`;
}